export default __webpack_public_path__ + "static/media/unSuccessfulMarker.c7c156a3.svg";